var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2165,
    height: 1527,
    viewBox: "0 0 2165 1527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2102.5,
    cy: 246.5,
    rx: 62.5,
    ry: 62.5,
    transform: "rotate(-180 2102.5 246.5)",
    fill: "#5C70F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2100,
    cy: 59.5,
    rx: 60,
    ry: 59.5,
    transform: "rotate(-180 2100 59.5)",
    fill: "#43B860"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2102.5,
    cy: 436.5,
    rx: 62.5,
    ry: 62.5,
    transform: "rotate(-180 2102.5 436.5)",
    fill: "#F0BA49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2103 245L27 1405",
    stroke: "#5C70F7",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100 59.0001L10 1227",
    stroke: "#43B860",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2103 433L173 1509",
    stroke: "#F0BA49",
    strokeWidth: 40
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.25e52d257c73a11f30fde93c6be709ea.svg";
export { ForwardRef as ReactComponent };